import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './GetOnlineButton.css';

interface IGetOnlineButtonProps {
  href: string;
  onClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const GetOnlineButton: React.FC<IGetOnlineButtonProps> = ({ href, onClick }) => {
  return (
    <a
      className={styles['button']}
      href={href}
      onClick={onClick}
      rel="noreferrer"
      target="_blank"
      data-testid="GetOnlineButton"
    >
      <UIText3>Получить онлайн</UIText3>
    </a>
  );
};
